import { render } from "./CrlsView.vue?vue&type=template&id=4acff25a&scoped=true"
import script from "./CrlsView.vue?vue&type=script&lang=js"
export * from "./CrlsView.vue?vue&type=script&lang=js"

import "./CrlsView.vue?vue&type=style&index=0&id=4acff25a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acff25a"]])

export default __exports__